module.exports = {"411402001":"平原街道","411402002":"长征街道","411402003":"前进街道","411402004":"白云街道","411402005":"东风街道","411402006":"八八街道","411402007":"建设街道","411402011":"解放街道","411402100":"谢集镇","411402101":"双八镇","411402103":"观堂镇","411402200":"刘口乡","411402201":"水池铺乡","411402203":"王楼乡","411402204":"李庄乡","411402205":"孙福集乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411402.json
// module id = 1653
// module chunks = 0